module.exports = __webpack_public_path__ + "static/media/101class.d1db135e.JPG";